import React, { Component } from "react";

export default class PromoContainer extends Component {
  render() {
    return (
      <div className="home">
        <div className="container">
          <div className="children">
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }
}
